import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformOptions (data) {
	return applyToOneOrMany(_transformOptions, data)
}

function _transformOptions (post) {

	post.clients_repeater.map((x) => {
		x.url = x.logo.sizes.bandara_medium
		x.featured = x.featured_on_home
	})

	post.footer = {
		title: post.title,
		content: post.content,
		icons: post.social_media_icons
	}

	post.defaultMeta = {
		'default_meta_description': post.default_meta_description ? post.default_meta_description : 'Virtual Reality Content Studio',
		'og_site_name': post.og_site_name ? post.og_site_name : 'Bandara',
		'default_og_image': post.default_og_image.sizes['bandara_social-share-large'] ? post.default_og_image.sizes['bandara_social-share-large'] : '',
		'og_facebook_admins': post.og_facebook_admins ? post.og_facebook_admins : '',
		'site_twitter_handle': post.site_twitter_handle ? post.site_twitter_handle : '',
		'publisher_facebook_page': post.publisher_facebook_page ? post.publisher_facebook_page : '',
		'publisher_google+_page': post['publisher_google+_page'] ? post['publisher_google+_page'] : '',
		'default_author_twitter_handle': post.default_author_twitter_handle ? post.default_author_twitter_handle : ''
	}

	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformOptions.js